import {
    BlurEvent,
    Button,
    ClickEvent,
    DataSourceExecutionEvent,
    DataSourceMode,
    LookupModelSelectionEvent,
    SaveButton,
    Snackbar,
    TableRow,
    TableRowDisplayEvent,
    TableRowMode,
    Textbox
} from "@mcleod/components";
import {Api, CurrencyUtil, ModelRow} from "@mcleod/core";
import {OtherChargesUtil, RateUtil} from "@mcleod/dispatch";
import {getDispatchControlBoolean} from "@mcleod/general";
import {AutogenLayoutEdiOrderRates} from "./autogen/AutogenLayoutEdiOrderRates";

export class EdiOrderRates extends AutogenLayoutEdiOrderRates {
    private _allocationEnabled: boolean;
    private _calculatingCharges = false;
    private chargePanelExpanded: boolean = true;
    private estimateFuelSurcharge: boolean = getDispatchControlBoolean("est_fuel_surcharge")
    private autoRate: boolean = getDispatchControlBoolean("auto_rate");
    private autoCalcMaxPay: boolean = getDispatchControlBoolean("auto_pay_rates");
    private saveButton: SaveButton;
    doAfterRating: () => void;
    checkPickupAndDeliveryEntered = () => true;

    override onLoad(): void {
        this.textboxCollectionMethod.items = RateUtil.getCollectionMethodDropdownItems();
        this.textboxCtrlParty.textCombined.manualAddLayout = null;
        this.textboxCtrlParty.textCombined.placeholder = "";
        this.buttonEstimateFuelSurcharge.visible = !this.estimateFuelSurcharge;
        this.buttonRate.enabled = (this.activeRow != undefined);
    }

    sourceSegAllocControlAfterExecution(event: DataSourceExecutionEvent){
        this._allocationEnabled = event.data?.get("is_active") === "Y" ? true : false as boolean;
        if(!this._allocationEnabled){
            this.textboxSegAllocCode.visible = this._allocationEnabled;
        }
    }

    sourceOrdersAfterExecution(event: DataSourceExecutionEvent) {
        RateUtil.setAutoRateContext(this, this.activeRow?.get("rate_id"), this.activeRow?.get("orig_dest_rate_id"));
        RateUtil.enableDisableUnitsAndRates(this, this.activeRow?.get("rate_type"), false);
    }

    set calculatingCharges(value: boolean) {
        this._calculatingCharges = value;
    }

    get calculatingCharges(): boolean {
        return this._calculatingCharges;
    }

    get getAllocationEnabled(): boolean {
        return this._allocationEnabled;
    }

    textboxSegAllocCodeBeforeLookupModelSearch(event) {
        event.filter.alloc_type = 'M';
        event.filter.is_active = 'Y';
    }

    buttonExpandChargesOnClick(event: ClickEvent) {
        const transitionProps = { speed: 100, paddingTop: 0 };
        if (this.chargePanelExpanded) this.panelOtherChargeTable.collapse(transitionProps).then(() => {
            this.buttonExpandCharges.imageRotation = 90
        }); else this.panelOtherChargeTable.expand(transitionProps).then(() => {
            this.buttonExpandCharges.imageRotation = 0
        });
        this.chargePanelExpanded = !this.chargePanelExpanded;
    }

    sourceOrdersAfterModeChange(event) {
        if ((event.newMode == DataSourceMode.ADD || event.newMode == DataSourceMode.UPDATE) && event.newMode != event.oldMode) {
            this.setupMaxTargetPanel(true);
            this.sourceOtherChargeEdi.mode = DataSourceMode.ADD;
        }
        if ((event.newMode == DataSourceMode.SEARCH)){
            this.sourceOtherChargeEdi.mode = DataSourceMode.SEARCH;
            this.textboxSegAllocCode.visible = this._allocationEnabled;
            this.textboxTotalCharge.printable = false;
            this.textboxTotalCharge.enabled = true;
            this.buttonRate.visible = false;
            this.buttonEstimateFuelSurcharge.visible = false;
            this.buttonAvailableCredit.visible = false;
        }
        RateUtil.setRateListeners(this);
    }

    private setupMaxTargetPanel(visible: boolean) {
        this.panelRateTotals.borderBottomRightRadius = visible ? 0 : 4;
        this.panelRateTotals.borderBottomLeftRadius = visible ? 0 : 4;
    }

    /** This is an event handler for the onRowDisplay event of tableOtherCharges.  */
    tableOtherChargesOnRowDisplay(event: TableRowDisplayEvent) {
        const chargeId: Textbox = event.getTableRow().findComponentById("textboxChargeId") as Textbox;
        const chargeDescr: Textbox = event.getTableRow().findComponentById("textboxDescr") as Textbox;
        const chargeDescr2: Textbox = event.getTableRow().findComponentById("textboxDescr2") as Textbox;
        const calcMethod: Textbox = event.getTableRow().findComponentById("textboxChargeCalcMethod") as Textbox;
        const chargecalcMethodSearch: Textbox = event.getTableRow().findComponentById("textboxCalcMethodSearch") as Textbox;
        const units: Textbox = event.getTableRow().findComponentById("textboxChargeUnits") as Textbox;
        const unitsSearch: Textbox = event.getTableRow().findComponentById("textboxUnitsSearch") as Textbox;
        const chargeRate: Textbox = event.getTableRow().findComponentById("textboxChargeRate") as Textbox;
        const chargeRateSearch: Textbox = event.getTableRow().findComponentById("textboxRateSearch") as Textbox;
        const chargeAmount: Textbox = event.getTableRow().findComponentById("textboxChargeAmount") as Textbox;
        const chargeAmountSearch: Textbox = event.getTableRow().findComponentById("textboxAmountSearch") as Textbox;
        if (chargeId != null && chargeId.text != null && chargeId.text != undefined && "I" === this.sourceViewEdiOrder?.activeRow?.get("direction")) {
            chargeId.enabled = false;
        }
        if (chargeId != null && chargeId.text != "" && chargeId.text != undefined){
            chargeDescr2.enabled = false;
            chargeDescr2.visible = false;
            chargecalcMethodSearch.enabled = false;
            chargecalcMethodSearch.visible = false;
            chargeRateSearch.enabled = false;
            chargeRateSearch.visible = false;
            chargeAmountSearch.enabled = false;
            chargeAmountSearch.visible = false;
            unitsSearch.visible = false;
            unitsSearch.enabled = false;
        }

        if ((chargeId.text == null || chargeId.text == "" || chargeId.text == undefined) && this.mainDataSource.mode == DataSourceMode.SEARCH) {
            chargeDescr.visible = false;
            chargeDescr.enabled = false;
            chargeDescr2.enabled = true;
            calcMethod.visible = false;
            calcMethod.enabled = false;
            chargecalcMethodSearch.enabled = true;
            units.visible = false;
            units.enabled = false;
            unitsSearch.enabled = true;
            chargeRate.visible = false;
            chargeRate.enabled = false;
            chargeRateSearch.enabled = true;
            chargeAmount.visible = false;
            chargeAmount.enabled = false;
            chargeAmountSearch.enabled = true;
        }
        if ("I" === this.sourceViewEdiOrder?.activeRow?.get("direction")) {
            event.getTableRow().allowDelete = false;
        }
    }

    async textboxChargeIdOnLookupModelSelection(event: LookupModelSelectionEvent) {
        if (event.hasSelection() === true) {
            const textboxDescr: Textbox = TableRow.getContainingTableRow(event.target)?.findComponentById("textboxDescr") as Textbox;
            if (textboxDescr != null)
                textboxDescr.text = event.selection.get("descr");
            await this.chargeIdChanged(event.target, event.selection);
        }
    }

    async textboxChargeRateOnBlur(event: BlurEvent) {
        if (event.changedWhileFocused) {
            const textbox: Textbox = event.target as Textbox;
            const orderInfo = {
                "order_distance": this.mainDataSource.activeRow.get("bill_distance", null),
                "order_weight": this.mainDataSource.activeRow.get("weight", null)
            };
            if (this.mainDataSource.activeRow.data["freight_charge"] != null) this.addCurrencyToProps(orderInfo, this.mainDataSource.activeRow, "freight_charge", "order_freight");
            if (await this.getOtherChargeTotal(false) != null) this.addCurrencyValueToProps(orderInfo, "previous_other_charge_total", await this.getOtherChargeTotal(false));

            Api.search("lme/datafusion/calculate-other-charge-edi", {
                "other_charge_row": TableRow.getContainingTableRow(textbox).data, "order_info": orderInfo
            }).then(response => {
                this.otherChargeFromApi(response, textbox);
            });
        }
    }

    buttonEstimateFuelSurchargeOnClick(event: ClickEvent) {
        this.ratingButtonClicked(event, false, true);
    }

    buttonRateOnClick(event: ClickEvent) {
        this.ratingButtonClicked(event, true);
    }

    ratingButtonClicked(event: ClickEvent, autoRate: boolean, estimateFsc: boolean = this.estimateFuelSurcharge) {
        const button = event.target as Button;
        button.busy = true;
        this.calculateRates(autoRate, estimateFsc).finally(() => {
            const orderId = this.mainDataSource.activeRow?.get("order_id");
            button.busy = false
            button.enabled = (orderId == null);
        });
    }

    buttonAvailableCreditOnClick(event: ClickEvent) {
        this.buttonAvailableCredit.busy = true;
        const row = this.mainDataSource.activeRow;
        const params = { customer_id: this.mainDataSource.activeRow.get("customer_id") };
        if (row.get("total_charge") != null) this.addCurrencyToProps(params, row, "total_charge", "order_total_charges");
        if (row.get("totalcharge_and_excisetax") != null) this.addCurrencyToProps(params, row, "totalcharge_and_excisetax", "order_total_charges_plus_excisetax");
        if (this.mainDataSource.mode != DataSourceMode.ADD && row.get("order_id") != null) params["exclude_order_id"] = row.get("order_id");

        Api.search("lme/ar/customer-balance", params).then(result => {
            const customerData = result?.data?.[0];
            if (customerData["available_credit"] == null) this.labelAvailableCredit.text = ""; else this.labelAvailableCredit.text = CurrencyUtil.formatCurrency(customerData["available_credit"]);
        }).finally(() => this.buttonAvailableCredit.busy = false);
    }

    async chargeIdChanged(textbox: Textbox, selectedRow: ModelRow) {
        const orderInfo = {
            "order_distance": this.mainDataSource.activeRow.get("bill_distance", null),
            "order_weight": this.mainDataSource.activeRow.get("weight", null)
        };
        if (this.mainDataSource.activeRow.data["freight_charge"] != null) this.addCurrencyToProps(orderInfo, this.mainDataSource.activeRow, "freight_charge", "order_freight");
        if (await this.getOtherChargeTotal(false) != null) this.addCurrencyValueToProps(orderInfo, "previous_other_charge_total", await this.getOtherChargeTotal(false));

        const selectedRowId = selectedRow.get("id");
        Api.search("lme/datafusion/calculate-other-charge-edi", {
            "charge_code": selectedRowId,
            "charge_id": selectedRowId,
            "other_charge_row": TableRow.getContainingTableRow(textbox).data,
            "order_info": orderInfo
        }).then(response => {
            this.otherChargeFromApi(response, textbox);
        });
    }

    private addCurrencyToProps(props, row: ModelRow, fieldName: string, propName: string) {
        const currencyValue = row.get(fieldName);
        this.addCurrencyValueToProps(props, propName, currencyValue);
    }

    private addCurrencyValueToProps(props: any, propName: string, currencyValue: any) {
        props[propName] = currencyValue;
    }

    async getOtherChargeTotal(includeFreightCharge: boolean) {
        const freightCharge = includeFreightCharge ? this.activeRow.get("freight_charge") : null;
        return await OtherChargesUtil.calculateOtherChargeTotal(this.sourceOtherChargeEdi, freightCharge);
    }

    private otherChargeFromApi(response, textbox: Textbox) {
        const data = response.data[0];
        const otherCharge = data["other_charge_row"];
        if (Object.keys(otherCharge).length > 0) {
            const row = TableRow.getContainingTableRow(textbox);
            row.data["calc_method"] = otherCharge["calc_method"];
            const calcMethod: Textbox = row.findComponentById("textboxChargeCalcMethod") as Textbox;
            const items = calcMethod.items;
            for (let i = 0; i < items.length; ++i) {
                if (items[i].value == otherCharge["calc_method"]) {
                    calcMethod.selectedItem = items[i];
                    break;
                }
            }
            const units: Textbox = row.findComponentById("textboxChargeUnits") as Textbox;
            units.text = otherCharge["units"]?.toString();
            const rate: Textbox = row.findComponentById("textboxChargeRate") as Textbox;
            rate.text = otherCharge["rate"]?.toString();
            TableRow.getContainingTableRow(textbox).data.set("amount", otherCharge["amount"]);

            const chargeRow: TableRow = TableRow.getContainingTableRow(textbox);
            chargeRow.data.set("amount", otherCharge["amount"]);
            const amount: Textbox = row.findComponentById("textboxChargeAmount") as Textbox;
            if (row.mode === TableRowMode.QUICK_ADD) amount.text = CurrencyUtil.formatCurrency(otherCharge["amount"])?.toString();
        }
    }

    async tableOtherChargesOnContentsChanged() {
        this.mainDataSource.activeRow.set("otherchargetotal", await this.getOtherChargeTotal(false));
        this.mainDataSource.activeRow.set("total_charge", await this.getOtherChargeTotal(true));
    }

    async calculateRates(autorate: boolean = this.autoRate, estimateFsc: boolean = this.estimateFuelSurcharge): Promise<any> {
        if (!this.mainDataSource.isAddingOrUpdating() || this.calculatingCharges || this.mainDataSource.activeRow == null) return Promise.resolve();
        this.mainDataSource.setComponentsBusy(true);
        this.calculatingCharges = true;
        const calcMaxTargetPay = this.shouldCalcMaxPay();
        try {
            const orderRow = this.mainDataSource.activeRow?.data;
            const response = await Api.search("lme/dispatch/calculate-order-charges", {
                "autorate": autorate,
                "estimate_fsc": estimateFsc,
                "order_row": orderRow,
                "order_type": "E",
                "calculate_max_target": calcMaxTargetPay
            });
            let totalChargeChanged = false;
            const data = response.data[0];
            if (!data) {
                Snackbar.showSnackbar("No valid rates found for this tender.");
                return;
            }
            const orderApiData = data["order_row"] || [];

            // Estimate Fuel Surcharge
            if (estimateFsc) {
                const appendingId: string[] = [];
                this.tableOtherCharges.rows.forEach(row => {
                    if (row.data?._appending == false) appendingId.push(row.data?._data["id"])
                });
                for (let i = this.tableOtherCharges.rows.length - 1; i >= 0; i--) {
                    const row = this.tableOtherCharges.rows[i];
                    if (row?.data?.data["est_fuel_surcharge"] === "Y") {
                        row.deleteRow()
                    }
                }
                this.sourceOtherChargeEdi.data = [];
                const otherCharges = data["other_charges"] || [];
                otherCharges.forEach(element => {
                    const isAppending = appendingId.length == 0 || !appendingId.includes(element["id"]);
                    const modelRow = new ModelRow(this.sourceOtherChargeEdi.url, isAppending);
                    modelRow.setValues(element);
                    this.sourceOtherChargeEdi.data.push(modelRow);
                });
                this.tableOtherCharges.displayData(null, this.sourceOtherChargeEdi.data, 0);
            }
            // Auto Rate
            this.textboxRateType.setSelectedItemFromValue(orderApiData["rate_type"]);
            this.mainDataSource.activeRow.set("rate_type", orderApiData["rate_type"]);
            this.mainDataSource.activeRow.set("bill_distance", orderApiData["bill_distance"]);
            this.mainDataSource.activeRow.set("autorate_status", orderApiData["autorate_status"]);
            this.mainDataSource.activeRow.set("rate", orderApiData["rate"]);
            this.mainDataSource.activeRow.data["calc_method"] = data["rate_type"];
            this.mainDataSource.activeRow.set("rate_units", orderApiData["rate_units"]);
            this.mainDataSource.activeRow.set("freight_charge", orderApiData["freight_charge"]);
            this.mainDataSource.activeRow.set("freight_charge_n", orderApiData["freight_charge_n"]);
            this.mainDataSource.activeRow.set("otherchargetotal", await this.getOtherChargeTotal(false));
            this.mainDataSource.activeRow.set("rate_id", orderApiData["rate_id"]);
            if (orderApiData["total_charge"] != null) {
                if (orderApiData["total_charge"].amount != this.mainDataSource.activeRow.get("total_charge")?.amount || 0) {
                    this.mainDataSource.activeRow.set("total_charge", orderApiData["total_charge"]);
                    this.mainDataSource.activeRow.set("total_charge_n", orderApiData["total_charge_n"]);
                    totalChargeChanged = true;
                }
            }
            if (orderApiData["totalcharge_and_excisetax"] != null) this.mainDataSource.activeRow.set("totalcharge_and_excisetax", orderApiData["order_total_charges_plus_excisetax"]);

            RateUtil.setAutoRateContext(this, orderApiData["rate_id"], orderApiData["orig_dest_rate_id"]);
            if (orderApiData["rate_id"] == null) {
                Snackbar.showSnackbar("No valid rates found for this tender.");
            }
            if (totalChargeChanged && this.doAfterRating != null) this.doAfterRating();
        } finally {
            this.calculatingCharges = false;
            this.mainDataSource.setComponentsBusy(false);
        }
    }

    shouldCalcMaxPay(): boolean {
        return false;
    }

    /** This is an event handler for the onChange event of checkboxLockMiles.  */
    checkboxLockMilesOnChange(event) {
       if(!(this.mainDataSource.mode === DataSourceMode.SEARCH)){
        this.textboxBillDistance.enabled = event.newValue === false;
       }

    }

}
